import { all, call } from "redux-saga/effects";
import { watchFetchRoadSpecialEventAudio } from "redux/sagas/audioPreview.saga";
import { watchFetchAnnouncementaudioAudio } from "redux/sagas/announcementAudio.saga";

import { watchFetchAnnouncements, watchSaveAnnouncements } from "redux/sagas/announcements.saga";
import { watchFetchRoadSpecialEvents, watchSaveRoadSpecialEvents } from "redux/sagas/specialEvents.saga";
import { watchFetchRoadXmlFiles, watchDownloadRoadXmlFiles } from "redux/sagas/xmlFiles.saga";
import { watchFetchRoadConditions, watchSaveRoadConditions } from "./redux/sagas/roadCondition.saga";

export function* rootSaga() {
  yield all([call(watchFetchRoadConditions), call(watchSaveRoadConditions),
  call(watchFetchRoadSpecialEvents), call(watchSaveRoadSpecialEvents),
  call(watchFetchRoadXmlFiles), call(watchDownloadRoadXmlFiles),
  call(watchFetchRoadSpecialEventAudio),call(watchFetchAnnouncementaudioAudio),
call(watchFetchAnnouncements), call(watchSaveAnnouncements)]);
}
